<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="(isSelf)?getApplyList:getAllApplyList"
      ref="firstReviewList"
      hide-title-search
      @click:row="getDetails($event.item)"
      :filter-items="(isSelf)?[]:filterItems"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      clickable>
      <template slot="title">
        <span class="pl-2 pr-4">二级单位审核（补卡）</span>
        <v-radio-group mandatory row v-model="isSelf">
          <v-radio :value="true" label="待审核申请"></v-radio>
          <v-radio :value="false" label="历史申请"></v-radio>
        </v-radio-group>
      </template>
      <!--<template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn icon :disabled="item.firstAuditStatus+''!=='0'" @click="review(item)">
            <v-icon>{{$vuetify.icons.edit}}</v-icon>
          </v-btn>
        </td>
      </template>-->
    </l-data-table>
  </l-layout>
</template>

<script>
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  import {time} from "../../../ladmin/utils/time";
  function reviewStatusTrans(v){
    switch (v+'') {
      case '1':return '已通过';
      case '2':return '已拒绝';
      case '0':return '待审核';
      case '-1':return 'N/A';
      default:return v;
    }
  }
  function transType(v) {
    switch (v+'') {
      case "0":return "普通类型"
      case "1":return "指标异常"
    }
  }
  export default {
    name: "firstReviewList",
    components: {LDataTable},
    data(){
      return {
        header:[
          {text:'申请教工',value:'name',sortable:false,align:'left'},
          {text:'教工号',value:'loginId',sortable:false,align:'left'},
          {text:'申请时间',value:'creationTime',sortable:false,align:'left',placeholder:'N/A',f:(v)=>time.stringify(v)},
          {text:'单位名称',value:'orgName',sortable: false,placeholder: 'N/A'},
          {text:'二级单位审核状态',value:'firstAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'校医院审核状态',value:'medicineAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'人事处审核状态',value:'secondAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
        ],
        selected:[],
        loading:false,
        isSelf:true,
        filterItems: [
          {
            prependIcon: '$vuetify.icons.person',
            key: 'name',
            value: '',
            label: '教工姓名',
            type: 'input',
            layout: ['xs12', 'sm4'],
          },
          {
            prependIcon: '$vuetify.icons.person',
            key: 'loginId',
            value: '',
            label: '教工编号',
            type: 'input',
            layout: ['xs12', 'sm4'],
          },
        ],
      }
    },
    computed:{
      curOrg(){
        return this.$store.state.login.currentOrg
      }
    },
    methods:{
      async getAllApplyList({pagination,filterItems}){
        let {items,amount} = await this.$store.dispatch('school/getExtraSignList',{pagination:pagination,filter:filterItems,search:{key:'orgId',value:this.curOrg.id}})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
            item.medicineAuditStatus = '-1'
          }
        }
        return {items:items,amount:amount}
      },
      async getApplyList({pagination}){
        let filter = [
          {key:'stage',value:'1'},
          {key:'firstAuditStatus',value:'0'}
        ]
        let {items,amount} = await this.$store.dispatch('school/getExtraSignList',{pagination:pagination,filter:filter,search:{key:'orgId',value:this.curOrg.id}})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
            item.medicineAuditStatus = '-1'
          }
        }
        return {items:items,amount:amount}
      },
      getDetails(item){
        if(item.firstAuditStatus==='0'){
          this.$router.push({name:'signApplyDetail',
            query:{
              id:item.id,
              status:'review',
              type:'1'
            }
          })
        }else{
          this.$router.push({name:'signApplyDetail',
            query:{
              id:item.id,
              status:'readonly'
            }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
